<template>
    <div class="land-flats-aqualina-apart active">
           <flatsFilter></flatsFilter>
		   <flatsCards></flatsCards>
            <!-- <a href="#" @click.prevent="getFlatsData">Получить квартиры</a> -->
    </div>   
</template>

<script>
    import {mapGetters} from 'vuex'
	import flatsFilter from '@/components/sales-land-partials/partials/aqualina-flats-partials/flat-filter.vue'
	import flatsCards from '@/components/sales-land-partials/partials/aqualina-flats-partials/flat-cards-aqualina.vue'
    export default {
        name: 'sale-land-flats-apart-aqualina',
        components: {
			flatsFilter,
			flatsCards,
        },
        data () {
            return {
                // for flats filter
            }
        },
        computed: mapGetters({
            salesCard: 'loadSalesCardContent',
            salesCardPage: 'loadSalesCardPage',
            salesCardFlats: 'loadFlatsCardsGlobal',
            salesCardFlatsDefault: 'loadFlatsCardsGlobalDefault',
        }),
        methods: {
        },
        beforeCreate() {
            // this.$store.dispatch('getFlatsCards', window.host).then((response) => {
            //    console.log('response complete')
            // });
        },
        created () {
        },
        mounted () {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/sales/sales-land-partials/land-flats.scss';
    @import '@/styles/respond/sales/sales-land-partials/land-flats-respond.scss';
    // @import '@/styles/respond/sales/respond-sale-item.scss';
</style>